import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import {
  getCompanyReportsSecrConfigRetrieveQueryKey,
  getCompanyReportsSecrResultsRetrieveQueryKey,
  useCompanyReportsSecrConfigRetrieve,
  useCompanyReportsSecrConfigUpdate,
  useCompanyReportsSecrResultsRetrieve,
} from '@shared/api/lib/company-reports/company-reports';
import { useQueryClient } from '@tanstack/react-query';

export type {
  SECRReportConfig,
  SECRReportResult,
  SECRCategoryTotals,
  SECRPriorYearOverrides,
  SECRPriorYearCategories,
  SECRPriorYearCategoryOverride,
  PriorYearSourceEnum,
  IntensityMetricTypeEnum,
} from '@shared/api/types';

export const useGetSecrConfig = (companyReportUuid: string) =>
  useCompanyReportsSecrConfigRetrieve(companyReportUuid, {
    request: useAxiosConfig(),
    query: {
      enabled: !!companyReportUuid,
    },
  });

export const useUpdateSecrConfig = () => {
  const queryClient = useQueryClient();
  return useCompanyReportsSecrConfigUpdate({
    request: useAxiosConfig(),
    mutation: {
      onSuccess: async (_data, variables) => {
        await queryClient.invalidateQueries(
          getCompanyReportsSecrConfigRetrieveQueryKey(
            variables.companyReportUuid
          )
        );
        await queryClient.invalidateQueries(
          getCompanyReportsSecrResultsRetrieveQueryKey(
            variables.companyReportUuid
          )
        );
      },
    },
  });
};

// retry: false so a pre-publish 404 surfaces cleanly instead of retrying
export const useGetSecrResults = (companyReportUuid: string) =>
  useCompanyReportsSecrResultsRetrieve(companyReportUuid, {
    request: useAxiosConfig(),
    query: {
      enabled: !!companyReportUuid,
      retry: false,
    },
  });
